import React from "react"
import { Box } from "@infotech/uikit-grid"
import cn from "classnames"
import { TrashIcon } from "@infotech/uikit-icons"
import DeletedIcon from "src/icons/deleted.svg"
import { Accordeon, AccordeonGroup } from "@infotech/uikit-accordeon"
import tooltip from "@infotech/uikit-tooltip"
import composeLodash from "lodash/fp/compose"
import values from "lodash/fp/values"
import groupBy from "lodash/fp/groupBy"
import styles from "./styles.css"

const TooltipSpan = tooltip.span()

const Option = ({
  isLast,
  eventUuid,
  option,
  availableQuery,
  allowedResourceTypesByStatus,
  deleteEventResource,
  isDisabled,
  isResourcesDisabled,
  getTestAttribute,
}) => {
  const showDelete = !(
    isDisabled ||
    allowedResourceTypesByStatus.includes(option.resourceTypeId) ||
    !deleteEventResource ||
    isResourcesDisabled
  )

  return (
    <Box
      loose
      className={cn(styles.OptionWrapper, !isLast && styles.WithBorder)}
    >
      <Box
        flex
        loose
        pl="2md"
        pr="2md"
        pt="1md"
        pb="1md"
        className={styles.Option}
      >
        {!!option.deletedBy && (
          <Box loose pr="2md">
            <DeletedIcon className={styles.DeletedIcon} />
          </Box>
        )}
        <Box loose className={styles.OptionTitle}>
          {option.name}
        </Box>
        <Box
          loose
          className={styles.TrashWrapper}
          data-testid={getTestAttribute(`resource-delete`)}
          onClick={() =>
            deleteEventResource({
              eventUuid,
              resourceUuid: option.uuid,
              resourceName: option.name,
              availableQuery,
            })
          }
        >
          {showDelete && (
            <TooltipSpan
              tooltip="Удалить"
              tooltipConfig={{
                placement: `top`,
              }}
            >
              <TrashIcon />
            </TooltipSpan>
          )}
        </Box>
      </Box>
    </Box>
  )
}

const GroupOption = ({
  eventUuid,
  group,
  availableQuery,
  allowedResourceTypesByStatus,
  deleteEventResource,
  isDisabled,
  isResourcesDisabled,
  getTestAttribute,
}) => (
  <div className={styles.GroupOptionWrapper}>
    {group.map((item, key) => (
      <Option
        isLast={key === group.length - 1}
        isDisabled={isDisabled}
        isResourcesDisabled={isResourcesDisabled}
        getTestAttribute={getTestAttribute}
        eventUuid={eventUuid}
        option={item}
        availableQuery={availableQuery}
        allowedResourceTypesByStatus={allowedResourceTypesByStatus}
        deleteEventResource={deleteEventResource}
      />
    ))}
  </div>
)

const ResourceList = ({
  eventUuid,
  isDisabled,
  isResourcesDisabled,
  getTestAttribute,
  resourcesList,
  deleteEventResource,
  availableQuery,
  allowedResourceTypesByStatus,
}) => {
  const groupedList = composeLodash(
    values,
    groupBy(({ resourceTypeId }) => resourceTypeId),
  )(
    resourcesList.map(({ ...rest }) => ({
      ...rest,
    })),
  )
  return (
    <>
      <AccordeonGroup defaultOpenIndexes={[0]}>
        {groupedList.map(item => (
          <Accordeon label={item[0].resourceTypeName}>
            <GroupOption
              eventUuid={eventUuid}
              group={item}
              isDisabled={isDisabled}
              isResourcesDisabled={isResourcesDisabled}
              getTestAttribute={getTestAttribute}
              availableQuery={availableQuery}
              allowedResourceTypesByStatus={allowedResourceTypesByStatus}
              deleteEventResource={deleteEventResource}
            />
          </Accordeon>
        ))}
      </AccordeonGroup>
    </>
  )
}

export default ResourceList
